<template>
  <PageContent>
    <StepsV2 :step="2" />
    <PanelV2
      type="w6"
      title="Enter your business details"
      @nextClick="commitData"
    >
      <template v-slot:title-solt>
        <BdoProgress :step="1" :total="3" />
      </template>
      <template v-slot:content-solt>
        <AppForm
          ref="appForm"
          v-model="formData"
        />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
import AppForm from "../forms/IndividualF.val";
import API from "@/api";
export default {
  name: "IndividualF",
  pRouter: "IndividualE",
  components: {
    AppForm,
  },
  data() {
    return {
      formData: {},
    };
  },
  methods: {
    commitData() {

        this.$refs.appForm.$refs.appForm.validate((valid) => {

          const data = this.formatCommitData({...this.formData, businessName: this.formData['businessName_1']})

          if (valid) {

            API.addBdoProcess({
              ...data
            }).then(res => {
              if (res.success) {
                this.toNext()
              }
            })
          }
        });
      }
    // commitData() {
    //   this.$refs.appForm.$refs.appForm.validate((valid) => {
    //     const formData = this.formData;
    //     console.log({
    //       valid,
    //       formData,
    //     });
    //     if (valid) {
    //       API.addBdoProcess({
    //         businessDetails: {
    //           businessDescription: formData.businessDescription,
    //           businessName: formData.businessName,
    //         },
    //         token: this.getCookieItem("token"),
    //         pageNo:"5"
    //       }).then((res) => {
    //         if (res.success === true) {
    //           // const { merchantId, mchPd } = {...res.message};
    //           // this.setMerchantId(merchantId);
    //           // mchPd && this.updateStepData({mchPd}, "mchPd");
    //           // this.updateFlowStep();
    //           this.toNext();
    //         }
    //       });
    //     }
    //   });
    // },
  },
};
</script>
